import { render, staticRenderFns } from "./FairImagePicker.vue?vue&type=template&id=0f475861&"
import script from "./FairImagePicker.vue?vue&type=script&lang=js&"
export * from "./FairImagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports